import AppConfig from "core/app-config";
import getAnalyticTags, { analyticsConfig } from "core/lib/analytics";
import { SearchResultItem } from "core/models/search-result-item";
import SearchStore, { DisplayMode } from "core/stores/search.store";

class DisplayModeTab {
  constructor(
    protected text: string,
    public mode: DisplayMode,
    public analyticsMeta: any = null,
    protected items: SearchResultItem[] = []) {
    this.mode = mode;
    this.items = items;
  }

  get tabText() {
    if (this.mode == DisplayMode.All) {
      return this.text;
    }

    const count = this.items.length;

    let results = AppConfig.results;
    results = results == "Results"
      ? `Result${count == 1 ? "" : "s"}`
      : results;

    return `${this.text} (${count} ${results})`;
  }

  get analytics() {
    if (this.mode == DisplayMode.All) {
      return {};
    }

    return getAnalyticTags(this.analyticsMeta);
  }
}

export const getTabs = (store: SearchStore) => {
  const { all, dealers, installers } = AppConfig;
  const tabs: DisplayModeTab[] = [
    new DisplayModeTab(all, DisplayMode.All, {}),
    new DisplayModeTab(dealers, DisplayMode.Dealers, analyticsConfig.dealersTab, store.dealers),
    new DisplayModeTab(installers, DisplayMode.Installers, analyticsConfig.installersTab, store.installers)
  ];

  return tabs;
}

export default DisplayModeTab;
